export const PageMixin = {
  async asyncData({ store, route, error, redirect, req }) {
    const params = route.path

    try {
      await store.dispatch('data/GET_PAGE_DATA', { params, error, redirect })
    } catch (e) {
      console.log(123,e);
      error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./mixins/PageMixin.js